<template>
  <div class="ui container">
    <table class="ui celled table">
      <thead>
      <tr>
        <th>排名</th>
        <th>经验</th>
        <th>头像</th>
        <th>名字</th>
        <th>明星</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users">
        <td>{{ user.sort }}</td>
        <td>{{ user.growth_num }}</td>
        <td>
          <img class="ui avatar image" :src="user.head_img">
        </td>
        <td>
          {{ user.name }}
        </td>
        <td>
          {{ user.star_name }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserRank',
  data() {
    return {
      users: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load() {
      axios.get('/mm/rank').then(({ data }) => {
        this.users = data.data
      })
    }
  }
}
</script>

<style scoped>

</style>
